import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IPaginationQueryParams } from "types/shared"
import { IGetDistrictsRes } from "types/district"

import districtsService from "api/districtsService"

const useGetDistricts = ({ sortBy = "name", pageIndex = 1, pageSize = 10 }: IPaginationQueryParams, enabled = true) => {
  return useQuery(["districts", { sortBy, pageIndex, pageSize }], async () => {
    try {
      const res: AxiosResponse<IGetDistrictsRes> = await districtsService.getDistricts({ sortBy, pageIndex, pageSize })

      return res.data
    }  catch (err: any) {
      return err.response
    }
  }, { enabled, refetchOnWindowFocus: false })
}

export default useGetDistricts